import { useQuery } from "@apollo/client";

import { MetricField, ReportingSortDirection } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetOrganicStatsQuery, type GetOrganicStatsQueryVariables, getOrganicStats } from "../api/queries";

import { type DimensionBreakdownParams } from "./useDimensionBreakdownQueryParams";

export const useDimensionBreakdownQuery = ({
    assetType,
    breakdownAssetType,
    lensId,
    startTime,
    endTime,
    selectedGranularity,
    fields,
}: DimensionBreakdownParams): ApolloResult<{ data: GetOrganicStatsQuery | undefined }> => {
    const { loading, error, data } = useQuery<GetOrganicStatsQuery, GetOrganicStatsQueryVariables>(getOrganicStats, {
        variables: {
            assetType,
            breakdownAssetType,
            lensId,
            startTime,
            endTime,
            granularity: selectedGranularity,
            fieldsList: fields,
            sortBy: MetricField.MetricFieldUnset,
            sortDirection: ReportingSortDirection.SortDirectionUnset,
            limit: 0,
        },
    });

    return { loading, error, data };
};
